<template>
  <div>
    <v-banner
      style="
        height: fit-content;
        width: 100%;
        object-fit: cover;
        position: relative;
        left: -5px;
      "
    >
      <img width="100%" height="250px" src="@/assets/images/dress.png" />
    </v-banner>
  </div>
</template>

<script>
export default {};
</script>
<style></style>
